export class TaskDocConfirmRequest {
  doNoList: string[];
  confirmUser: string;
  doLockHeader: string | null;
  taskClassName: string;
  isReturn: boolean;

  constructor() {
    this.doNoList = [];
    this.confirmUser = "";
    this.doLockHeader = "";
    this.taskClassName = "";
    this.isReturn = false;
  }
}
